module.exports = __webpack_public_path__ + "img/p2.27f581f4.jpg";